import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  AppBar,
  Toolbar,
  Container,
  Paper,
  alpha,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Description as FileText,
  Refresh as RefreshCw,
  Public as Globe,
  Edit,
  Check,
  TrendingUp,
  Speed,
  Translate,
  FormatQuote,
  Business,
  MenuBook,
  Campaign,
} from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import GavelIcon from "@mui/icons-material/Gavel";

const toolsData = [
  {
    id: "Summarizer",
    icon: FileText,
    color: "#3B82F6",
    gradientStart: "#3B82F6",
    gradientEnd: "#1E40AF",
    title: "AI Summarizer",
    description: "Turn long texts into clear, impactful summaries",
    features: [
      "Extract key points automatically",
      "Adjustable summary length",
      "Multiple document formats",
    ],
    badge: "Fast",
    badgeColor: "#3B82F6",
    fontSize: 16,
    buttonText: "Summarize",
    buttonIcon: TrendingUp,
  },
  {
    id: "paraphrase",
    icon: RefreshCw,
    color: "#10B981",
    gradientStart: "#10B981",
    gradientEnd: "#047857",
    title: "AI Paraphraser",
    description: "Transform text for clarity and originality.",
    features: [
      "Multiple writing styles",
      "Preserve original meaning",
      "Plagiarism-free content",
    ],
    badge: "Accurate",
    fontSize: 16,
    badgeColor: "#10B981",
    buttonText: "Paraphrase",
    buttonIcon: RefreshCw,
  },
  {
    id: "translator",
    icon: Globe,
    color: "#8B5CF6",
    gradientStart: "#8B5CF6",
    gradientEnd: "#6D28D9",
    title: "AI Translator",
    description: "Break language barriers with accurate, natural translations",
    features: [
      "100+ languages supported",
      "Context-aware translation",
      "Cultural adaptation",
    ],
    badge: "Multi-language",
    fontSize: 16,
    badgeColor: "#8B5CF6",
    buttonText: "Translate",
    buttonIcon: Translate,
  },

  {
    id: "plagiarism",
    icon: GavelIcon,
    color: "#e34c1fff",
    gradientStart: "#e34c1fff",
    gradientEnd: "#e34c1fff",
    title: "AI Plagiarism Checker",
    description:
      "Ensure originality with advanced AI-powered plagiarism detection",
    features: [
      "Scans across millions of web sources",
      "Identifies exact and paraphrased matches",
      "Provides detailed similarity reports",
    ],
    badge: "Originality Check",
    fontSize: 16,
    badgeColor: "#e34c1fff",
    buttonText: "Plagiarism",
    buttonIcon: GavelIcon,
  },

  {
    id: "citation",
    icon: FormatQuote,
    color: "#b7a500",
    gradientStart: "#b7a500",
    gradientEnd: "#b7a500",
    title: "AI Citation Generator",
    description:
      "Generate accurate, properly formatted citations instantly with AI-powered precision",
    features: [
      "Supports major citation styles (APA, MLA, Chicago, and more)",
      "Automatically extracts and formats source details",
      "Ensures academic accuracy and consistency",
    ],
    badge: "Smart Citation",
    fontSize: 16,
    badgeColor: "#b7a500",
    buttonText: "Citation",
    buttonIcon: FormatQuote,
  },
  {
    id: "business-tools",
    icon: Business,
    color: "#0EA5E9",
    gradientStart: "#0EA5E9",
    gradientEnd: "#0369A1",
    title: "AI Business Tools",
    description: "Enhance your business operations with intelligent AI solutions",
    features: [
      "Automated report generation",
      "Data analysis and insights",
      "Business process optimization",
    ],
    badge: "Professional",
    fontSize: 16,
    badgeColor: "#0EA5E9",
    buttonText: "Business Tools",
    buttonIcon: Business,
  },
  {
    id: "book-writing",
    icon: MenuBook,
    color: "#F59E0B",
    gradientStart: "#F59E0B",
    gradientEnd: "#D97706",
    title: "AI Book Writing",
    description: "Craft compelling stories and books with AI assistance",
    features: [
      "Plot and character development",
      "Chapter outline generation",
      "Writing style adaptation",
    ],
    badge: "Creative",
    fontSize: 16,
    badgeColor: "#F59E0B",
    buttonText: "Write Book",
    buttonIcon: MenuBook,
  },
  {
    id: "advertising-tool",
    icon: Campaign,
    color: "#EC4899",
    gradientStart: "#EC4899",
    gradientEnd: "#BE185D",
    title: "AI Advertising Tool",
    description: "Create high-converting ads with AI-powered optimization",
    features: [
      "Ad copy generation",
      "Target audience analysis",
      "Performance prediction",
    ],
    badge: "High-Converting",
    fontSize: 16,
    badgeColor: "#EC4899",
    buttonText: "Create Ads",
    buttonIcon: Campaign,
  },
];

export default function MultiToolWorkspace() {
  const [hoveredCard, setHoveredCard] = useState(null);
  const history = useHistory();
  const handleToolSelect = (toolId) => {
    console.log(`Navigating to: ${toolId}`);
    {
      history.push({
        pathname: `/${toolId}`,
      });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: `linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)`,
        backgroundBlendMode: "overlay",
        backgroundImage:
           `radial-gradient(at 20% 30%, rgba(59,130,246,0.15) 0px, transparent 50%),
radial-gradient(at 80% 70%, rgba(139,92,246,0.15) 0px, transparent 50%),
radial-gradient(at 50% 50%, rgba(16,185,129,0.08) 0px, transparent 60%)`}}
    >

            <div
  style={{
    height: "5vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <h2
    style={{
      color: "#012a83",
      fontSize: "18px",
      fontWeight: "100",
      fontstyle:"bold",
      letterSpacing: "2px",
      margin: 0,
    }}
  >
    AI TOOL SUITE
  </h2>
</div>
      {/* Main Content */}
      <Box sx={{ flex: 1, overflow: "auto" }}>
        <Container maxWidth="lg" sx={{ py: 6 }}>
          {/* Enhanced Header */}
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: "rgb(11, 79, 231);",
                mb: 2,
                letterSpacing: "-0.02em",
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              <Typography variant="h3" fontWeight="700" gutterBottom>
                🔮 Powerful AI Writing & Business Tools
              </Typography>
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: "#000000ff",
                mb: 4,
                fontWeight: 400,
                fontfamily: "cursive",
                maxWidth: 700,
                mx: "auto",
                lineHeight: 1.6,
              }}
            >
              Transform your content, business, and creative projects with our advanced AI-powered tools. 
              From writing to advertising, we have everything you need.
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 1.5,
                justifyContent: "center",
                flexWrap: "wrap",
                paddingTop: "10px",
              }}
            >
              <Chip
                label="⚡ Lightning Fast"
                sx={{
                  bgcolor: alpha("#3B82F6", 0.1),
                  color: "#1E40AF",
                  fontWeight: 600,
                  fontSize: 16,
                  px: 1,
                  border: "1px solid",
                  borderColor: alpha("#3B82F6", 0.2),
                }}
              />
              <Chip
                label="🎯 Accurate"
                sx={{
                  bgcolor: alpha("#10B981", 0.1),
                  color: "#065F46",
                  fontWeight: 600,
                  fontSize: 16,
                  px: 1,
                  border: "1px solid",
                  borderColor: alpha("#10B981", 0.2),
                }}
              />
              <Chip
                label="🌍 45+ Languages"
                sx={{
                  bgcolor: alpha("#8B5CF6", 0.1),
                  color: "#5B21B6",
                  fontWeight: 600,
                  fontSize: 16,
                  px: 1,
                  border: "1px solid",
                  borderColor: alpha("#8B5CF6", 0.2),
                }}
              />
              <Chip
                label="💼 Business Ready"
                sx={{
                  bgcolor: alpha("#0EA5E9", 0.1),
                  color: "#0369A1",
                  fontWeight: 600,
                  fontSize: 16,
                  px: 1,
                  border: "1px solid",
                  borderColor: alpha("#0EA5E9", 0.2),
                }}
              />
            </Box>
          </Box>

          {/* Enhanced Tools Grid */}
          <Grid container spacing={3}>
            {toolsData.map((tool) => {
              const Icon = tool.icon;
              const ButtonIcon = tool.buttonIcon;
              const isHovered = hoveredCard === tool.id;

              return (
                <Grid xs={12} sm={6} lg={3} key={tool.id}>
                  <Card
                    onMouseEnter={() => setHoveredCard(tool.id)}
                    onMouseLeave={() => setHoveredCard(null)}
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                      overflow: "visible",
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      border: "1px solid",
                      borderColor: isHovered
                        ? alpha(tool.color, 0.3)
                        : "divider",
                      boxShadow: isHovered
                        ? `0 20px 40px ${alpha(
                            tool.color,
                            0.15
                          )}, 0 0 0 1px ${alpha(tool.color, 0.1)}`
                        : "0 1px 3px rgba(0,0,0,0.05)",
                      transform: isHovered
                        ? "translateY(-8px) scale(1.02)"
                        : "translateY(0) scale(1)",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 4,
                        background: `linear-gradient(90deg, ${tool.gradientStart}, ${tool.gradientEnd})`,
                        opacity: isHovered ? 1 : 0,
                        transition: "opacity 0.3s",
                      },
                    }}
                  >
                    <CardContent sx={{ flexGrow: 1, p: 3 }}>
                      {/* Icon with gradient background */}
                      <Box
                        sx={{
                          position: "relative",
                          width: 56,
                          height: 56,
                          borderRadius: 2.5,
                          background: `linear-gradient(135deg, ${tool.gradientStart}, ${tool.gradientEnd})`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 2.5,
                          boxShadow: `0 8px 24px ${alpha(tool.color, 0.3)}`,
                          transform: isHovered
                            ? "rotate(-5deg) scale(1.1)"
                            : "rotate(0deg) scale(1)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                      >
                        <Icon sx={{ fontSize: 28, color: "#FFFFFF" }} />
                      </Box>

                      {/* Badge */}
                      <Chip
                        label={tool.badge}
                        size="small"
                        sx={{
                          height: 24,
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          bgcolor: alpha(tool.badgeColor, 0.1),
                          color: tool.badgeColor,
                          border: "1px solid",
                          borderColor: alpha(tool.badgeColor, 0.2),
                          mb: 2,
                        }}
                      />

                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          mb: 1.5,
                          color: "#111827",
                          letterSpacing: "-0.01em",
                          fontSize: "1.25rem",
                        }}
                      >
                        {tool.title}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000000",
                          mb: 3,
                          lineHeight: 1.6,
                          fontSize: "0.875rem",
                        }}
                      >
                        {tool.description}
                      </Typography>

                      {/* Features List */}
                      <List dense sx={{ p: 0 }}>
                        {tool.features.map((feature, idx) => (
                          <ListItem key={idx} sx={{ px: 0, py: 0.75 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <Box
                                sx={{
                                  width: 20,
                                  height: 20,
                                  borderRadius: "50%",
                                  bgcolor: alpha(tool.color, 0.1),
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Check
                                  sx={{ fontSize: 14, color: tool.color }}
                                />
                              </Box>
                            </ListItemIcon>
                            <ListItemText
                              primary={feature}
                              primaryTypographyProps={{
                                fontSize: "0.8rem",
                                color: "#000000",
                                fontWeight: 500,
                              }}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>

                    {/* Enhanced Action Button */}
                    <Box sx={{ p: 3, pt: 0 }}>
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={<ButtonIcon sx={{ fontSize: 20 }} />}
                        onClick={() => handleToolSelect(tool.id)}
                        sx={{
                          background: isHovered
                            ? `linear-gradient(135deg, ${tool.gradientStart}, ${tool.gradientEnd})`
                            : alpha(tool.color, 0.1),
                          color: isHovered ? "#FFFFFF" : tool.color,
                          fontWeight: 600,
                          py: 1.5,
                          textTransform: "none",
                          fontSize: "0.9rem",
                          boxShadow: isHovered
                            ? `0 8px 20px ${alpha(tool.color, 0.3)}`
                            : "none",
                          border: isHovered
                            ? "none"
                            : `2px solid ${alpha(tool.color, 0.2)}`,
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            background: `linear-gradient(135deg, ${tool.gradientStart}, ${tool.gradientEnd})`,
                            transform: "scale(1.02)",
                            boxShadow: `0 12px 28px ${alpha(tool.color, 0.4)}`,
                          },
                        }}
                      >
                        {tool.buttonText}
                      </Button>
                    </Box>
                  </Card>
                </Grid>
              );
            })}
          </Grid>

          {/* Bottom CTA Section */}
          <Paper
            elevation={0}
            sx={{
              mt: 6,
              p: 4,
              textAlign: "center",
              background:
                "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 3,
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, mb: 1, color: "#111827" }}
            >
              🤖 Ready to transform your writing and business?
            </Typography>
            <Typography variant="body1" sx={{ color: "#6B7280", mb: 3 }}>
              Join thousands of users who trust our AI-powered tools for their
              content and business needs.
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#000000ff",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Check sx={{ fontSize: 16, color: "#10B981" }} /> Free to
                start-T&C
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#000000ff",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Check sx={{ fontSize: 16, color: "#10B981" }} /> Synthium Creative Suite
                Enhanced Security
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#000000ff",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Check sx={{ fontSize: 16, color: "#10B981" }} /> End-to-End
                Encryption
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#000000ff",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Check sx={{ fontSize: 16, color: "#10B981" }} /> Business &
                Creative Tools
              </Typography>
            </Box>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
}




// import React, { useState } from "react";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Chip,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Avatar,
//   Container,
//   Paper,
//   alpha,
//   GlobalStyles,
//   ThemeProvider,
//   createTheme,
//   CssBaseline,
// } from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";
// import {
//   Description as FileText,
//   Refresh as RefreshCw,
//   Public as Globe,
//   Check,
//   TrendingUp,
//   Translate,
//   FormatQuote,
//   Business,
//   MenuBook,
//   Campaign,
// } from "@mui/icons-material";
// import { useHistory } from "react-router-dom";
// import GavelIcon from "@mui/icons-material/Gavel";

// // ─── Galaxy background (same as Dashboard) ────────────────────────────────────
// const GALAXY_BG = `
//  radial-gradient(circle at 20% 30%, rgba(255,255,255,0.35), transparent 40%),
// radial-gradient(circle at 80% 70%, rgba(170,150,255,0.25), transparent 45%),
// linear-gradient(
// 165deg,
// #1a0b5e 0%,
// #2436a8 12%,
// #7b6cf6 22%,
// #b7b0f5 32%,
// #e9e6fb 42%,
// #f5f3ff 50%,
// #e2d7ff 58%,
// #c0a9ff 68%,
// #9b7df2 78%,
// #4a2bbf 88%,
// #1a0b5e 100%
//   )`;

// const STARS = Array.from({ length: 90 }, (_, i) => ({
//   x:  ((i * 2539 + 419) % 10000) / 100,
//   y:  ((i * 1733 + 137) % 10000) / 100,
//   sz: i % 11 === 0 ? 3.4 : i % 5 === 0 ? 2.2 : i % 3 === 0 ? 1.6 : 1.0,
//   dl: ((i * 0.31) % 5.5).toFixed(2),
//   dr: (1.6 + (i % 8) * 0.45).toFixed(1),
//   bright: i % 6 === 0,
// }));

// // ─── MUI Theme (same as Dashboard) ───────────────────────────────────────────
// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary:    { main: "#8848d8", light: "#c090ff", dark: "#5820a8" },
//     secondary:  { main: "#d858e8", light: "#ee98ff", dark: "#a020b8" },
//     success:    { main: "#25b085", light: "#50c8a5", dark: "#108060" },
//     warning:    { main: "#e87025", light: "#f5a050", dark: "#c05508" },
//     error:      { main: "#e85050", light: "#f58080", dark: "#c02020" },
//     info:       { main: "#2a7af4", light: "#80b0ff", dark: "#2060c8" },
//     background: { default: "#0e0157", paper: "rgba(255,255,255,0.08)" },
//     text:       { primary: "#ffffff", secondary: "rgba(255,250,255,0.80)" },
//     divider:    "rgba(255,255,255,0.20)",
//   },
//   typography: {
//     fontFamily: '"Outfit","Segoe UI",sans-serif',
//     h4: { fontWeight: 800, letterSpacing: "-0.02em" },
//     h6: { fontWeight: 700 },
//     body1: { fontSize: "0.875rem" },
//   },
//   shape: { borderRadius: 16 },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           backdropFilter:       "blur(30px) saturate(170%)",
//           WebkitBackdropFilter: "blur(30px) saturate(170%)",
//           border:               "1px solid rgba(255,255,255,0.18)",
//           borderRadius:         20,
//           transition:           "all 0.4s cubic-bezier(0.175,0.885,0.32,1.275)",
//           backgroundImage:      "none",
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius:  50,
//           textTransform: "none",
//           fontWeight:    600,
//           fontSize:      "0.88rem",
//           backdropFilter: "blur(14px)",
//           transition:    "all 0.28s ease",
//           "&:hover":     { transform: "translateY(-2px)" },
//         },
//       },
//     },
//     MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
//   },
// });

// // ─── Global keyframe animations ───────────────────────────────────────────────
// const GalaxyGlobals = () => (
//   <GlobalStyles
//     styles={`
//       @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');
//       @keyframes gxTwinkle {
//         0%,100% { opacity:0.12; transform:scale(0.55); }
//         50%      { opacity:1.00; transform:scale(1.55); }
//       }
//       @keyframes gxArm1 {
//         0%  { opacity:0.58; transform:rotate(-18deg) translate(0px,0px) scale(1.00); }
//         50% { opacity:0.88; transform:rotate(-14deg) translate(18px,-12px) scale(1.02); }
//         100%{ opacity:0.58; transform:rotate(-18deg) translate(0px,0px) scale(1.00); }
//       }
//       @keyframes gxArm2 {
//         0%  { opacity:0.48; transform:rotate(12deg) translate(0px,0px) scale(1.00); }
//         50% { opacity:0.75; transform:rotate(15deg) translate(-14px,14px) scale(1.02); }
//         100%{ opacity:0.48; transform:rotate(12deg) translate(0px,0px) scale(1.00); }
//       }
//       @keyframes gxCore {
//         0%,100% { opacity:0.88; transform:scale(1.00); }
//         50%      { opacity:1.00; transform:scale(1.07); }
//       }
//       @keyframes gxBreath {
//         0%,100% { opacity:0.42; transform:scale(1.00); }
//         50%      { opacity:0.65; transform:scale(1.05); }
//       }
//       @keyframes gxFloat {
//         from { opacity:0; transform:translateY(20px) scale(0.97); }
//         to   { opacity:1; transform:translateY(0px) scale(1.00); }
//       }
//     `}
//   />
// );

// // ─── Animated stars layer ────────────────────────────────────────────────────
// const DashStars = () => (
//   <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 0, overflow: "hidden" }}>
//     {STARS.map((s, i) => (
//       <Box
//         key={i}
//         sx={{
//           position: "absolute",
//           left: `${s.x}%`,
//           top:  `${s.y}%`,
//           width:  `${s.sz}px`,
//           height: `${s.sz}px`,
//           borderRadius: "50%",
//           background: "#ffffff",
//           boxShadow: `0 0 ${(s.sz * 3.2).toFixed(1)}px rgba(255,255,255,0.95), 0 0 ${(s.sz * 1.6).toFixed(1)}px rgba(255,255,255,0.82)${s.bright ? `, 0 0 ${(s.sz * 7).toFixed(1)}px rgba(255,255,255,0.52)` : ""}`,
//           animation: `gxTwinkle ${s.dr}s ease-in-out ${s.dl}s infinite`,
//         }}
//       />
//     ))}
//   </Box>
// );

// // ─── Atmospheric glow overlays ────────────────────────────────────────────────
// const Atmosphere = () => (
//   <>
//     <Box sx={{ position: "absolute", top: "22%", left: "32%", width: "48%", height: "42%", background: "radial-gradient(ellipse, rgba(255,255,255,0.96) 0%, rgba(255,252,255,0.82) 10%, rgba(255,235,248,0.65) 24%, rgba(255,218,242,0.44) 40%, rgba(248,200,255,0.22) 58%, transparent 78%)", filter: "blur(22px)", pointerEvents: "none", zIndex: 1, animation: "gxCore 5.5s ease-in-out infinite" }} />
//     <Box sx={{ position: "absolute", top: "-12%", left: "-20%", width: "102%", height: "65%", background: "linear-gradient(148deg, rgba(255,255,255,0.34) 0%, rgba(255,254,255,0.24) 18%, rgba(248,235,255,0.16) 36%, rgba(235,218,255,0.08) 55%, transparent 75%)", borderRadius: "50%", transform: "rotate(-18deg)", filter: "blur(14px)", pointerEvents: "none", zIndex: 1, animation: "gxArm1 18s ease-in-out infinite" }} />
//     <Box sx={{ position: "absolute", bottom: "-12%", right: "-15%", width: "95%", height: "60%", background: "linear-gradient(148deg, rgba(255,255,255,0.30) 0%, rgba(255,252,255,0.20) 20%, rgba(245,228,255,0.12) 42%, rgba(232,215,255,0.06) 60%, transparent 78%)", borderRadius: "50%", transform: "rotate(12deg)", filter: "blur(16px)", pointerEvents: "none", zIndex: 1, animation: "gxArm2 22s ease-in-out infinite" }} />
//     <Box sx={{ position: "absolute", top: "12%", left: "18%", width: "68%", height: "62%", background: "radial-gradient(ellipse at 52% 48%, rgba(255,235,248,0.48) 0%, rgba(255,222,242,0.30) 28%, rgba(250,210,255,0.15) 52%, transparent 72%)", filter: "blur(36px)", pointerEvents: "none", zIndex: 1, animation: "gxBreath 9s ease-in-out infinite" }} />
//     <Box sx={{ position: "absolute", top: "-10%", right: "-8%", width: "50%", height: "48%", background: "radial-gradient(ellipse, rgba(205,228,255,0.54) 0%, rgba(188,215,255,0.32) 32%, rgba(205,222,255,0.14) 55%, transparent 72%)", filter: "blur(32px)", pointerEvents: "none", zIndex: 1 }} />
//     <Box sx={{ position: "absolute", top: "-5%", left: "-5%", width: "40%", height: "44%", background: "radial-gradient(ellipse, rgba(108,62,185,0.58) 0%, rgba(122,78,200,0.34) 36%, transparent 64%)", filter: "blur(30px)", pointerEvents: "none", zIndex: 1 }} />
//     <Box sx={{ position: "absolute", bottom: "-5%", left: "8%", width: "58%", height: "32%", background: "radial-gradient(ellipse, rgba(198,148,250,0.40) 0%, rgba(210,165,255,0.22) 42%, transparent 68%)", filter: "blur(30px)", pointerEvents: "none", zIndex: 1 }} />
//   </>
// );

// // ─── Tools data (unchanged) ───────────────────────────────────────────────────
// const toolsData = [
//   {
//     id: "Summarizer",
//     icon: FileText,
//     color: "#3B82F6",
//     gradientStart: "#3B82F6",
//     gradientEnd: "#1E40AF",
//     title: "AI Summarizer",
//     description: "Turn long texts into clear, impactful summaries",
//     features: ["Extract key points automatically", "Adjustable summary length", "Multiple document formats"],
//     badge: "Fast",
//     badgeColor: "#3B82F6",
//     buttonText: "Summarize",
//     buttonIcon: TrendingUp,
//   },
//   {
//     id: "paraphrase",
//     icon: RefreshCw,
//     color: "#10B981",
//     gradientStart: "#10B981",
//     gradientEnd: "#047857",
//     title: "AI Paraphraser",
//     description: "Transform text for clarity and originality.",
//     features: ["Multiple writing styles", "Preserve original meaning", "Plagiarism-free content"],
//     badge: "Accurate",
//     badgeColor: "#10B981",
//     buttonText: "Paraphrase",
//     buttonIcon: RefreshCw,
//   },
//   {
//     id: "translator",
//     icon: Globe,
//     color: "#8B5CF6",
//     gradientStart: "#8B5CF6",
//     gradientEnd: "#6D28D9",
//     title: "AI Translator",
//     description: "Break language barriers with accurate, natural translations",
//     features: ["100+ languages supported", "Context-aware translation", "Cultural adaptation"],
//     badge: "Multi-language",
//     badgeColor: "#8B5CF6",
//     buttonText: "Translate",
//     buttonIcon: Translate,
//   },
//   {
//     id: "plagiarism",
//     icon: GavelIcon,
//     color: "#e34c1f",
//     gradientStart: "#e34c1f",
//     gradientEnd: "#b83410",
//     title: "AI Plagiarism Checker",
//     description: "Ensure originality with advanced AI-powered plagiarism detection",
//     features: ["Scans across millions of web sources", "Identifies exact and paraphrased matches", "Provides detailed similarity reports"],
//     badge: "Originality Check",
//     badgeColor: "#e34c1f",
//     buttonText: "Plagiarism",
//     buttonIcon: GavelIcon,
//   },
//   {
//     id: "citation",
//     icon: FormatQuote,
//     color: "#f6de08",
//     gradientStart: "#f6de08",
//     gradientEnd: "#f6de08",
//     title: "AI Citation Generator",
//     description: "Generate accurate, properly formatted citations instantly with AI-powered precision",
//     features: ["Supports major citation styles (APA, MLA, Chicago, and more)", "Automatically extracts and formats source details", "Ensures academic accuracy and consistency"],
//     badge: "Smart Citation",
//     badgeColor: "##f6de08",
//     buttonText: "Citation",
//     buttonIcon: FormatQuote,
//   },
//   {
//     id: "business-tools",
//     icon: Business,
//     color: "#0EA5E9",
//     gradientStart: "#0EA5E9",
//     gradientEnd: "#0369A1",
//     title: "AI Business Tools",
//     description: "Enhance your business operations with intelligent AI solutions",
//     features: ["Automated report generation", "Data analysis and insights", "Business process optimization"],
//     badge: "Professional",
//     badgeColor: "#0EA5E9",
//     buttonText: "Business Tools",
//     buttonIcon: Business,
//   },
//   {
//     id: "book-writing",
//     icon: MenuBook,
//     color: "#F59E0B",
//     gradientStart: "#F59E0B",
//     gradientEnd: "#D97706",
//     title: "AI Book Writing",
//     description: "Craft compelling stories and books with AI assistance",
//     features: ["Plot and character development", "Chapter outline generation", "Writing style adaptation"],
//     badge: "Creative",
//     badgeColor: "#F59E0B",
//     buttonText: "Write Book",
//     buttonIcon: MenuBook,
//   },
//   {
//     id: "advertising-tool",
//     icon: Campaign,
//     color: "#EC4899",
//     gradientStart: "#EC4899",
//     gradientEnd: "#BE185D",
//     title: "AI Advertising Tool",
//     description: "Create high-converting ads with AI-powered optimization",
//     features: ["Ad copy generation", "Target audience analysis", "Performance prediction"],
//     badge: "High-Converting",
//     badgeColor: "#EC4899",
//     buttonText: "Create Ads",
//     buttonIcon: Campaign,
//   },
// ];

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function MultiToolWorkspace() {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const history = useHistory();

//   const handleToolSelect = (toolId) => {
//     history.push({ pathname: `/${toolId}` });
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <GalaxyGlobals />

//       {/* Galaxy background wrapper */}
//       <Box sx={{ position: "relative", minHeight: "100vh", overflow: "hidden", background: GALAXY_BG }}>
//         <DashStars />
//         <Atmosphere />

//         {/* Content layer */}
//         <Box sx={{ position: "relative", zIndex: 2 }}>

//           {/* Top label bar */}
//           <Box sx={{
//             height: "5vh",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             borderBottom: "1px solid rgba(255,255,255,0.10)",
//             backdropFilter: "blur(10px)",
//           }}>
//             <Typography sx={{
//               color: "#ffffff",
//               fontSize: "18px",
//               fontWeight: 600,
//               letterSpacing: "4px",
//               textTransform: "uppercase",
//               textShadow: "0 0 20px rgba(192,144,255,0.60)",
//             }}>
//               AI TOOL SUITE
//             </Typography>
//           </Box>

//           <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>

//             {/* Header */}
//             <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
//               <Typography variant="h3" sx={{
//                 fontWeight: 800,
//                 color: "#ffffff",
//                 mb: 2,
//                 letterSpacing: "-0.02em",
//                 fontSize: { xs: "1.8rem", md: "2.5rem" },
//                 textShadow: "0 2px 24px rgba(192,144,255,0.70)",
//               }}>
//                 🔮 Powerful AI Writing & Business Tools
//               </Typography>

//               <Typography variant="h6" sx={{
//                 color: "rgba(255,248,255,0.82)",
//                 mb: 4,
//                 fontWeight: 400,
//                 maxWidth: 700,
//                 mx: "auto",
//                 lineHeight: 1.6,
//                 fontSize: { xs: "0.95rem", md: "1.1rem" },
//               }}>
//                 Transform your content, business, and creative projects with our advanced AI-powered tools.
//                 From writing to advertising, we have everything you need.
//               </Typography>

//               {/* Feature chips */}
//               <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center", flexWrap: "wrap" }}>
//                 {[
//                   { label: "⚡ Lightning Fast",  bg: "rgba(59,130,246,0.18)",  color: "#001731", border: "rgba(59,130,246,0.35)" },
//                   { label: "🎯 Accurate",        bg: "rgba(16,185,129,0.18)",  color: "#003c24", border: "rgba(16,185,129,0.35)" },
//                   { label: "🌍 45+ Languages",   bg: "rgba(139,92,246,0.18)",  color: "#12005b", border: "rgba(139,92,246,0.35)" },
//                   { label: "💼 Business Ready",  bg: "rgba(14,165,233,0.18)",  color: "#002d41", border: "rgba(14,165,233,0.35)" },
//                 ].map((chip) => (
//                   <Chip
//                     key={chip.label}
//                     label={chip.label}
//                     sx={{
//                       bgcolor: chip.bg,
//                       color: chip.color,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                       px: 1,
//                       border: "1px solid",
//                       borderColor: chip.border,
//                       backdropFilter: "blur(10px)",
//                     }}
//                   />
//                 ))}
//               </Box>
//             </Box>

//             {/* Tools Grid — responsive: 1 col xs, 2 col sm, 4 col lg */}
//             <Grid container spacing={3}>
//               {toolsData.map((tool) => {
//                 const Icon = tool.icon;
//                 const ButtonIcon = tool.buttonIcon;
//                 const isHovered = hoveredCard === tool.id;

//                 return (
//                   <Grid xs={12} sm={6} lg={3} key={tool.id}>
//                     <Card
//                       onMouseEnter={() => setHoveredCard(tool.id)}
//                       onMouseLeave={() => setHoveredCard(null)}
//                       sx={{
//                         height: "100%",
//                         display: "flex",
//                         flexDirection: "column",
//                         position: "relative",
//                         overflow: "visible",
//                         cursor: "pointer",
//                         // Galaxy-style glassmorphism card
//                         background: isHovered
//                           ? `linear-gradient(145deg, ${alpha(tool.color, 0.22)} 0%, ${alpha(tool.color, 0.10)} 50%, rgba(255,255,255,0.06) 100%)`
//                           : "linear-gradient(145deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0.03) 100%)",
//                         border: `1px solid ${isHovered ? alpha(tool.color, 0.55) : "rgba(255,255,255,0.18)"}`,
//                         boxShadow: isHovered
//                           ? `0 20px 48px ${alpha(tool.color, 0.28)}, 0 0 0 1px ${alpha(tool.color, 0.18)}, inset 0 1px 0 rgba(255,255,255,0.20)`
//                           : "0 8px 32px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.12)",
//                         transform: isHovered ? "translateY(-8px) scale(1.02)" : "translateY(0) scale(1)",
//                         animation: "gxFloat 0.55s ease both",
//                         // Gradient top bar on hover
//                         "&::before": {
//                           content: '""',
//                           position: "absolute",
//                           top: 0, left: 0, right: 0,
//                           height: 3,
//                           background: `linear-gradient(90deg, ${tool.gradientStart}, ${tool.gradientEnd})`,
//                           opacity: isHovered ? 1 : 0,
//                           transition: "opacity 0.3s",
//                           borderRadius: "20px 20px 0 0",
//                         },
//                         // Shimmer bottom line
//                         "&::after": {
//                           content: '""',
//                           position: "absolute",
//                           bottom: 0, left: "12%", width: "76%", height: "1px",
//                           background: `linear-gradient(90deg, transparent, ${alpha(tool.color, 0.50)}, transparent)`,
//                           opacity: isHovered ? 1 : 0.4,
//                           transition: "opacity 0.3s",
//                         },
//                       }}
//                     >
//                       <CardContent sx={{ flexGrow: 1, p: { xs: 2.5, md: 3 } }}>

//                         {/* Icon */}
//                         <Box sx={{
//                           position: "relative",
//                           width: 56, height: 56,
//                           borderRadius: 2.5,
//                           background: `linear-gradient(135deg, ${tool.gradientStart}, ${tool.gradientEnd})`,
//                           display: "flex", alignItems: "center", justifyContent: "center",
//                           mb: 2.5,
//                           boxShadow: `0 8px 24px ${alpha(tool.color, 0.40)}, 0 0 0 4px ${alpha(tool.color, 0.12)}`,
//                           transform: isHovered ? "rotate(-5deg) scale(1.1)" : "rotate(0deg) scale(1)",
//                           transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
//                         }}>
//                           <Icon sx={{ fontSize: 28, color: "#FFFFFF" }} />
//                         </Box>

//                         {/* Badge */}
//                         <Chip
//                           label={tool.badge}
//                           size="small"
//                           sx={{
//                             height: 24,
//                             fontSize: "0.72rem",
//                             fontWeight: 700,
//                             bgcolor: alpha(tool.badgeColor, 0.18),
//                             color: tool.badgeColor,
//                             border: "1px solid",
//                             borderColor: alpha(tool.badgeColor, 0.38),
//                             mb: 2,
//                             backdropFilter: "blur(8px)",
//                           }}
//                         />

//                         <Typography variant="h5" sx={{
//                           fontWeight: 700, mb: 1.5,
//                           color: "#000000",
//                           letterSpacing: "-0.01em",
//                           fontSize: { xs: "1.05rem", md: "1.15rem" },
//                           textShadow: "0 1px 8px rgba(0,0,0,0.30)",
//                         }}>
//                           {tool.title}
//                         </Typography>

//                         <Typography variant="body2" sx={{
//                           color: "rgb(0, 0, 0)",
//                           mb: 3,
//                           lineHeight: 1.65,
//                           fontSize: "0.85rem",
//                         }}>
//                           {tool.description}
//                         </Typography>

//                         {/* Features */}
//                         <List dense sx={{ p: 0 }}>
//                           {tool.features.map((feature, idx) => (
//                             <ListItem key={idx} sx={{ px: 0, py: 0.6 }}>
//                               <ListItemIcon sx={{ minWidth: 30 }}>
//                                 <Box sx={{
//                                   width: 20, height: 20,
//                                   borderRadius: "50%",
//                                   bgcolor: alpha(tool.color, 0.18),
//                                   border: `1px solid ${alpha(tool.color, 0.38)}`,
//                                   display: "flex", alignItems: "center", justifyContent: "center",
//                                 }}>
//                                   <Check sx={{ fontSize: 13, color: tool.color }} />
//                                 </Box>
//                               </ListItemIcon>
//                               <ListItemText
//                                 primary={feature}
//                                 primaryTypographyProps={{
//                                   fontSize: "0.78rem",
//                                   color: "rgb(0, 0, 0)",
//                                   fontWeight: 500,
//                                 }}
//                               />
//                             </ListItem>
//                           ))}
//                         </List>
//                       </CardContent>

//                       {/* CTA Button */}
//                       <Box sx={{ p: 3, pt: 0 }}>
//                         <Button
//                           fullWidth
//                           variant="contained"
//                           startIcon={<ButtonIcon sx={{ fontSize: 20 }} />}
//                           onClick={() => handleToolSelect(tool.id)}
//                           sx={{
//                             background: isHovered
//                               ? `linear-gradient(135deg, ${tool.gradientStart}, ${tool.gradientEnd})`
//                               : `rgba(255,255,255,0.08)`,
//                             color: isHovered ? "#FFFFFF" : alpha(tool.color, 0.95),
//                             fontWeight: 700,
//                             py: 1.5,
//                             textTransform: "none",
//                             fontSize: "0.88rem",
//                             borderRadius: 3,
//                             boxShadow: isHovered ? `0 8px 20px ${alpha(tool.color, 0.40)}` : "none",
//                             border: isHovered ? "none" : `1.5px solid ${alpha(tool.color, 0.35)}`,
//                             backdropFilter: "blur(14px)",
//                             transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                             "&:hover": {
//                               background: `linear-gradient(135deg, ${tool.gradientStart}, ${tool.gradientEnd})`,
//                               transform: "scale(1.02) translateY(-2px)",
//                               boxShadow: `0 12px 28px ${alpha(tool.color, 0.50)}`,
//                               color: "#FFFFFF",
//                             },
//                           }}
//                         >
//                           {tool.buttonText}
//                         </Button>
//                       </Box>
//                     </Card>
//                   </Grid>
//                 );
//               })}
//             </Grid>

//             {/* Bottom CTA */}
//             <Paper
//               elevation={0}
//               sx={{
//                 mt: { xs: 4, md: 6 },
//                 p: { xs: 3, md: 4 },
//                 textAlign: "center",
//                 background: "linear-gradient(135deg, rgba(55,18,135,0.50) 0%, rgba(107,45,212,0.36) 100%)",
//                 backdropFilter: "blur(26px)",
//                 border: "1px solid rgba(192,144,255,0.28)",
//                 borderRadius: 3,
//                 boxShadow: "0 8px 38px rgba(80,40,180,0.22)",
//                 position: "relative",
//                 overflow: "hidden",
//                 // Top shimmer line
//                 "&::before": {
//                   content: '""',
//                   position: "absolute",
//                   top: 0, left: "18%", width: "64%", height: "1px",
//                   background: "linear-gradient(90deg, transparent, rgba(192,144,255,0.70), transparent)",
//                 },
//               }}
//             >
//               <Typography variant="h5" sx={{
//                 fontWeight: 700, mb: 1,
//                 color: "#ffffff",
//                 textShadow: "0 2px 16px rgba(192,144,255,0.50)",
//                 fontSize: { xs: "1.1rem", md: "1.35rem" },
//               }}>
//                 🤖 Ready to transform your writing and business?
//               </Typography>
//               <Typography variant="body1" sx={{ color: "rgba(255,248,255,0.72)", mb: 3 }}>
//                 Join thousands of users who trust our AI-powered tools for their content and business needs.
//               </Typography>
//               <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
//                 {[
//                   "Free to start — T&C",
//                   "Synthium Creative Suite Enhanced Security",
//                   "End-to-End Encryption",
//                   "Business & Creative Tools",
//                 ].map((item) => (
//                   <Typography
//                     key={item}
//                     variant="body2"
//                     sx={{
//                       color: "rgba(255,248,255,0.82)",
//                       display: "flex", alignItems: "center", gap: 0.6,
//                       fontWeight: 500,
//                     }}
//                   >
//                     <Check sx={{ fontSize: 16, color: "#50c8a5" }} />
//                     {item}
//                   </Typography>
//                 ))}
//               </Box>
//             </Paper>

//           </Container>
//         </Box>
//       </Box>
//     </ThemeProvider>
//   );
// }